import { Fragment } from 'react';
import { GRAND_TOP, GRAND_PRIZE_COUNT } from '../campaign';
import { Crop, Rays, SectionTitle } from './Shared';
import { ChevronSmIcon } from './Icons';

const DEFAULT_PRIZES = { total: GRAND_PRIZE_COUNT, top: GRAND_TOP };

/* Dark band with the top three grand prizes and a link to the full list.
   `prizes` is { total, top: [{ art, name, sub, win, badge }] } from the API. */
export default function GrandPrizes({ prizes = DEFAULT_PRIZES, onViewAll }) {
  return (
    <div className="gq-band">
      <Rays />
      <SectionTitle variant="grand">Golden Chest Prizes</SectionTitle>
      <div className="gq-gsub">Stand a chance to win from a pool of mega prizes</div>
      <div className="gq-gcard">
        {prizes.top.slice(0, 3).map((p, i) => (
          <Fragment key={p.name}>
            <div className={`gq-r${i + 1}`}>
              <Crop kind={p.art} className={`gq-im${i + 1}`} />
              {p.badge && <div className="gq-gp"><span>{p.badge}</span></div>}
              <div className="gq-t gq-nm">{p.name}</div>
              <div className="gq-t gq-sub">{p.sub}</div>
              <div className="gq-t gq-win">{p.win}</div>
            </div>
            <div className={`gq-dv gq-d${i + 1}`} />
          </Fragment>
        ))}
        <button type="button" className="gq-more" onClick={onViewAll}>
          View all {prizes.total} grand prizes<ChevronSmIcon />
        </button>
      </div>
    </div>
  );
}
